import * as React from "react";
import {BankAccountType} from "../../../../model/transaction/Transaction";

interface IProps {
	value: BankAccountType;
}

export const BankAccountTypePresenter: React.SFC<IProps> = (props) => {
	return (
		<span>{BankAccountType[props.value as any]}</span>
	);
};
